<template>
  <form name="form" v-on:submit.prevent="submit" v-on:change="changeHandler">
    <div class="card-body">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <selectlist
            name="title"
            v-model="form.title_id"
            :options="titles"
            label="Title"
            placeholder="Please Select"
          ></selectlist>
          <inputbox
            v-model="form.first_name"
            name="first_name"
            label="First Name"
          ></inputbox>
          <inputbox
            v-model="form.last_name"
            name="last_name"
            label="Last Name"
          ></inputbox>
          <selectlist
            name="gender"
            v-model="form.gender_id"
            :options="genders"
            label="Gender"
            placeholder="Please Select"
          ></selectlist>

          <fieldset>
            <legend>
              Contact Details
            </legend>
            <toggleswitch
              :labels="true"
              name="contact_details_known"
              v-model="form.contact_details_known"
              label="Does the client know the third party's contact details?"
            ></toggleswitch>
            <div v-if="form.contact_details_known">
              <inputbox
                name="email_address"
                label="Email Address"
                type="email"
                v-model="form.email_address"
              ></inputbox>

              <inputbox
                name="telephone"
                label="Telephone"
                v-model="form.telephone"
              ></inputbox>
            </div>
          </fieldset>
          <fieldset>
            <legend>
              Address Details
            </legend>
            <toggleswitch
              :labels="true"
              name="address_details_known"
              v-model="form.address_details_known"
              label="Does the client know the third party's address?"
            ></toggleswitch>

            <div v-if="form.address_details_known">
              <address-lookup
                :address="address"
                v-on:address="setAddress"
              ></address-lookup>
            </div>
          </fieldset>
          <fieldset>
            <legend>
              Insurance Details
            </legend>
            <selectlist
              name="insurer"
              :options="insurers"
              v-model="form.insurer_id"
              label="Insurer"
              placeholder="Please Select"
              label-name="name"
            ></selectlist>
            <inputbox
              name="gta"
              label="Is GTA?"
              :readonly="true"
              v-model="isGTA"
            ></inputbox>
            <inputbox
              name="policy_number"
              label="Policy Number"
              v-model="form.policy_number"
            ></inputbox>
            <inputbox
              name="claim_number"
              label="Claim Number"
              v-model="form.claim_number"
            ></inputbox>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="card-footer text-right">
      <button
        v-if="mode === 'edit'"
        class="btn btn-danger btn-raised float-left"
        name="delete"
        v-on:click.prevent="deleteThirdParty"
      >
        <i class="icon icon-delete"></i> Delete
      </button>
      <button
        class="btn btn-primary btn-raised"
        name="cancel"
        v-on:click.prevent="cancel"
      >
        <i class="icon icon-cancel"></i> Back
      </button>
      <button
        class="btn btn-primary btn-raised"
        name="save"
        v-on:click.prevent="handleUpdate"
      >
        <i class="icon icon-save"></i> Save
      </button>
    </div>
  </form>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },

    thirdParty: {
      type: String
    },

    mode: {
      type: String
    }
  },

  data() {
    return {
      titles: [],
      genders: [],
      insurers: [],
      form: new window.Form({
        title_id: null,
        first_name: null,
        last_name: null,
        gender_id: null,
        contact_details_known: false,
        email_address: null,
        telephone: null,
        address_details_known: false,
        address_line_one: null,
        address_line_two: null,
        city: null,
        postcode: null,
        insurer_id: null,
        policy_number: null,
        claim_number: null
      }),
      has_third_party: false,
      identifier: null,
      data_entered: false
    };
  },

  mounted() {
    this.mount();
  },

  computed: {
    isGTA() {
      if (this.form.insurer_id) {
        let insurer = this.insurers.find(insurer => {
          return insurer.id === parseInt(this.form.insurer_id);
        });

        if (insurer && insurer.gta) {
          return 'Yes';
        }

        return 'No';
      }

      return 'Please Select an Insurer';
    },

    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    }
  },

  methods: {
    mount() {
      window.Ajax.get('/titles')
        .then(response => {
          this.titles = response.data;
        })
        .catch(error => {});

      window.Ajax.get('/genders')
        .then(response => {
          this.genders = response.data;
        })
        .catch(error => {});

      window.Ajax.get('/insurers')
        .then(response => {
          this.insurers = response.data;
        })
        .catch(error => {});

      if (this.thirdParty) {
        window.Ajax.get(
          `/incidents/${this.incident}/third-parties/${this.thirdParty}`
        )
          .then(response => {
            if (response.data) {
              this.has_third_party = true;
              let data = response.data;

              this.form.title_id = data.title_id;
              this.form.first_name = data.first_name;
              this.form.last_name = data.last_name;
              this.form.gender_id = data.gender_id;
              this.form.contact_details_known = data.contact_details_known;
              this.form.email_address = data.email_address;
              this.form.telephone = data.telephone;
              this.form.address_details_known = data.address_details_known;
              this.form.address_line_one = data.address_line_one;
              this.form.address_line_two = data.address_line_two;
              this.form.city = data.city;
              this.form.postcode = data.postcode;
              this.form.insurer_id = data.insurer_id;
              this.form.policy_number = data.policy_number;
              this.form.claim_number = data.claim_number;
            }
          })
          .catch(error => {});
      }
    },

    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    changeHandler() {
      if (!this.data_entered) {
        this.data_entered = true;
      }
      this.$emit('unsaved-data', this.data_entered);
    },

    deleteThirdParty() {
      window
        .swal({
          title: 'Are you sure?',
          text: 'You cannot undo this',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.indicator = true;
            window.Ajax.delete(
              `/incidents/${this.incident}/third-parties/${this.thirdParty}`
            )
              .then(response => {
                this.$emit('deleted', this.thirdParty);
                this.indicator = false;
                this.$router.push(
                  `/first-notice-of-loss-plus/${this.incident}#parties`
                );
              })
              .catch(error => {
                this.indicator = false;
                window.toastify.error(
                  'Error',
                  'Sorry, there was an error deleting the third party.'
                );
              });
          }
        })
        .catch(error => {});
    },

    handleUpdate() {
      this.mode === 'add' ? this.submit() : this.updateThirdParty();
    },

    updateThirdParty() {
      this.form
        .put(`/incidents/${this.incident}/third-parties/${this.thirdParty}`)
        .then(response => {
          this.$emit('updated', response);
          window.toastify.success(
            'Success!',
            'The third party was updated successfully!'
          );
          // reset monitoring of form changes
          this.data_entered = false;
          this.$emit('unsaved-data', this.data_entered);
        })
        .catch(response => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error updating the third party'
          );
        });
    },

    submit() {
      this.form
        .post(`/incidents/${this.incident}/third-parties`)
        .then(response => {
          this.$emit('created', response.identifier);
          window.toastify.success(
            'Success!',
            'The third party was created successfully!'
          );
          // reset monitoring of form changes
          this.data_entered = false;
          this.$emit('unsaved-data', this.data_entered);
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'There was an error creating the third party.'
          );
        });
    },

    cancel() {
      window
        .swal({
          title: 'Are you sure?',
          text: 'You will lose any unsaved changes',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.$emit('close');
          }
          this.$router.push(
            `/first-notice-of-loss-plus/${this.incident}#parties`
          );
        })
        .catch(error => {});
    }
  },

  watch: {
    $route(to, from) {
      this.mount();
    }
  }
};
</script>
